import React, {
  Component,
  type PropsWithChildren,
  type ReactNode,
} from 'react';

type Props = PropsWithChildren<{
  root: Element | null;
  rootMargin: string;
  threshold: number | number[];
  onIntersect: () => void;
  className?: string;
}>;

class InterObserver extends Component<Props> {
  static defaultProps = {
    root: null,
    rootMargin: '50px',
    threshold: 0,
  };

  ref = React.createRef<HTMLDivElement>();

  observer: IntersectionObserver | null = null;

  componentDidMount(): void {
    if (this.ref.current && typeof IntersectionObserver !== 'undefined') {
      const { root, rootMargin, threshold } = this.props;
      const options = {
        root,
        rootMargin,
        threshold,
      };

      this.observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          this.props.onIntersect();
        }
      }, options);
      this.observer.observe(this.ref.current);
    }
  }

  componentWillUnmount(): void {
    if (this.observer && this.ref.current) {
      this.observer.unobserve(this.ref.current);
    }
  }

  render(): ReactNode {
    return (
      <div ref={this.ref} className={this.props.className}>
        {this.props.children}
      </div>
    );
  }
}

export default InterObserver;
